import type { LeaseActionProps } from '../../../models/Types';
import ArchiveLeaseExtensionModal from '../../ArchiveLeaseExtensionModal';

export default function OpenModalArchiveLeaseExtension({ ...props }: LeaseActionProps) {
  return <ArchiveLeaseExtensionModal {...props} />;
}
